import React from 'react';
import { TableProps } from 'antd';
import { Planogram } from '@/components/CreatePickList/types';
import { StyledTable } from './styles';
import { PlanogramProductCreateFromProduct } from '../PlanogramReview/type';
import { columns } from './columns';

export const TableListProduct = (
    props: TableProps<PlanogramProductCreateFromProduct>,
) => {
    return (
        <StyledTable
            {...props}
            columns={columns}
            scroll={{
                x: 'max-content',
            }}
            bordered
            size="middle"
            tableLayout="fixed"
        />
    );
};
